<div class="wizard__wrapper__image">
  <div class="row">
    <div class="col-xl-12 col-lg-12">
      <h2>
        <span>{{ "Images" | translate }}</span>
        <span *ngIf="experienceOrigin"
          ><a
            class="origin__icon"
            href="{{ experienceOriginUrl }}"
            target="_blank"
          ></a
        ></span>
      </h2>
      <h3>{{ "Cover image" | translate }}</h3>
      <p class="general__tip">
        <span></span>{{ "Recommended image size is 750x400" | translate }}
      </p>
      <p
        *ngIf="!generalInfoByLang.selectedCoverImage"
        class="general__tip--red"
      >
        {{ "Cover mandatory" | translate }}
      </p>

      <div class="row">
        <div class="col-xl-6">
          <div class="form-row">
            <div class="form-group col-md-9 col-sm-9 form--nopadding">
              <input
                id="files"
                type="file"
                class="form-control col-md-12"
                accept="image/*"
                (change)="fileChangeListener($event)"
              />
              <input
                type="text"
                class="form-control col-md-12"
                placeholder="{{ selectImagePlaceHolder | translate }}"
                disabled
              />
            </div>
            <div class="form-group col-md-3 col-sm-3">
              <label
                class="button button--purple button--big button--big--fullWidth"
                for="files"
                >{{ "Browse" | translate }}</label
              >
            </div>
          </div>
          <p *ngIf="coverTypeError" class="general__tip general__tip--red">
            {{ "Only images are allowed to be uploaded" | translate }}
          </p>
          <p *ngIf="coverSizeError" class="general__tip general__tip--red">
            {{ "Files should not exceed 12mb" | translate }}
          </p>
        </div>
      </div>
      <div class="row">
        <div class="col-xl-6">
          <image-cropper
            *ngIf="loadedImage || generalInfoByLang.activeCoverImage"
            [multipleImages]="false"
            (coverImage)="coverImageGet($event)"
            [src]="loadedImage"
            [experience]="experienceId"
            [activeCoverImage]="generalInfoByLang.activeCoverImage"
          >
          </image-cropper>
        </div>
        <div class="col-xl-5 offset-xl-1 tips">
          <div
            *ngIf="hasIssue && comments && commentImmage"
            class="general__tips general__tips--red"
          >
            <div *ngFor="let comment of comments; index as i">
              <h2
                *ngIf="!comment.isResolved && comment.type == 'IMAGES'"
                class="text-danger"
              >
                {{ "You have unresolved issues" | translate }}
              </h2>
              <div *ngIf="!comment.isResolved && comment.type == 'IMAGES'">
                <h3>{{ "Image information" | translate }}</h3>
                <p class="text-danger">{{ comment.comment }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row mb-5">
        <div class="col-xl-6">
          <h3>{{ "Gallery" | translate }}</h3>
          <p class="general__tip">
            <span></span>{{ "Recommended image size is 750x400" | translate }}
          </p>
          <ngx-file-drop
            dropZoneLabel="Drop files here"
            (onFileDrop)="dropped($event)"
            dropZoneClassName="multiimage__cropper"
            contentClassName="multiimage_content"
          >
            <ng-template
              ngx-file-drop-content-tmp
              let-openFileSelector="openFileSelector"
            >
              <div class="multiimage_content">
                <h3>{{ "Drag & drop files here" | translate }}</h3>
                <button
                  type="button"
                  class="button button--purple button--small"
                  (click)="openFileSelector()"
                >
                  {{ "+ Add Files" | translate }}
                </button>
              </div>
            </ng-template>
          </ngx-file-drop>
          <p *ngIf="galleryTypeError" class="general__tip general__tip--red">
            {{ "Only images are allowed to be uploaded" | translate }}
          </p>
          <p *ngIf="gallerySizeError" class="general__tip general__tip--red">
            {{ "Files should not exceed 12mb" | translate }}
          </p>

          <p *ngIf="galleryLengthError" class="general__tip general__tip--red">
            {{ "Maximum of 6 items is allowed" | translate }}
          </p>
        </div>
      </div>
      <div class="row">
        <div class="col-xl-6">
          <div
            *ngIf="generalInfoByLang.loadedImagesArray"
            class="cropped__images__wrapper"
          >
            <div class="row">
              <div
                *ngFor="
                  let gallery of generalInfoByLang?.loadedImagesArray;
                  let i = index
                "
                class="cropped__image col-xl-4 col-lg-4 col-md-4 col-sm-4 col-4 mb-3"
              >
                <div
                  class="cropped__image__background"
                  [style.background-image]="'url(' + gallery.original + ')'"
                ></div>
                <div class="cropped__overlay__wrapper">
                  <div
                    (click)="removeImage(gallery.id, i)"
                    class="cropped__image__overlay"
                  >
                    <h3>{{ "Remove" | translate }}</h3>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
